import RequestService from '@tcc-online/request-service';

export const SurveyService = {
    getProjects,
    getProject,
};

async function getProjects() {
    return await RequestService.get('/overview/projects');
}

async function getProject(id: number) {
    return await RequestService.get(`/overview/project/${id}`);
}
